import { createMemoryHistory, createBrowserHistory } from 'history';

const isServer = !(typeof window !== 'undefined' && window.document);
const history = isServer ? createMemoryHistory() : createBrowserHistory();

export default history;
